<template>
  <div class="sc-wrap">

    <!-- ── Header ── -->
    <div class="sc-header">
      <div class="sc-header-left">
        <div class="sc-header-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <polyline points="16,18 22,12 16,6" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="8,6 2,12 8,18" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <div class="sc-header-title">Scripts do Site</div>
          <div class="sc-header-sub">Scripts injetados automaticamente no &lt;body&gt; de todas as páginas</div>
        </div>
      </div>
      <button class="sc-btn-new" @click="abrirModal()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
          <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
        Novo Script
      </button>
    </div>

    <!-- ── Banner informativo ── -->
    <div class="sc-banner">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/>
        <path d="M12 16v-4M12 8h.01" stroke="#E86A10" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>Os scripts <strong>ativos</strong> são injetados no <code>&lt;body&gt;</code> do site automaticamente quando a página carrega. Use para Google Analytics, Facebook Pixel, Hotjar, Tag Manager, etc.</span>
    </div>

    <!-- ── Loading ── -->
    <div v-if="loading" class="sc-loading">
      <div class="sc-spinner"></div>
      <span>Carregando scripts...</span>
    </div>

    <!-- ── Erro ── -->
    <div v-else-if="erro" class="sc-error">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="#f87171" stroke-width="2"/>
        <path d="M12 8v4M12 16h.01" stroke="#f87171" stroke-width="2" stroke-linecap="round"/>
      </svg>
      {{ erro }}
    </div>

    <!-- ── Lista ── -->
    <div v-else>
      <div v-if="!scripts.length" class="sc-empty">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <polyline points="16,18 22,12 16,6" stroke="rgba(255,255,255,0.15)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <polyline points="8,6 2,12 8,18" stroke="rgba(255,255,255,0.15)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p>Nenhum script cadastrado</p>
        <button class="sc-btn-new sc-btn-new--sm" @click="abrirModal()">Adicionar primeiro script</button>
      </div>

      <div v-else class="sc-list">
        <div v-for="s in scripts" :key="s.id" class="sc-card" :class="{ 'sc-card--active': s.ativo }">
          <div class="sc-card-left">
            <div class="sc-card-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <polyline points="16,18 22,12 16,6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="8,6 2,12 8,18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="sc-card-info">
              <div class="sc-card-nome">{{ s.nome }}</div>
              <div class="sc-card-preview">{{ previewScript(s.script) }}</div>
              <div class="sc-card-meta">Atualizado {{ formatDate(s.updated_at) }}</div>
            </div>
          </div>

          <div class="sc-card-right">
            <label class="sc-toggle" :title="s.ativo ? 'Desativar' : 'Ativar'">
              <input type="checkbox" :checked="s.ativo" @change="toggleAtivo(s)" />
              <span class="sc-toggle-track">
                <span class="sc-toggle-thumb"></span>
              </span>
            </label>
            <span class="sc-badge" :class="s.ativo ? 'sc-badge--on' : 'sc-badge--off'">
              {{ s.ativo ? 'Ativo' : 'Inativo' }}
            </span>
            <button class="sc-btn-act sc-btn-edit" title="Editar" @click="abrirModal(s)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            <button class="sc-btn-act sc-btn-delete" title="Excluir" @click="confirmarExclusao(s)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <polyline points="3,6 5,6 21,6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M19 6l-1 14H6L5 6M10 11v6M14 11v6M9 6V4h6v2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Modal Criar/Editar ── -->
    <div v-if="modal.aberto" class="sc-modal-overlay" @click.self="fecharModal">
      <div class="sc-modal">
        <div class="sc-modal-header">
          <div class="sc-modal-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <polyline points="16,18 22,12 16,6" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="8,6 2,12 8,18" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ modal.editando ? 'Editar Script' : 'Novo Script' }}
          </div>
          <button class="sc-modal-close" @click="fecharModal">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>

        <div class="sc-modal-body">
          <div class="sc-field">
            <label class="sc-label">Nome do script <span class="sc-required">*</span></label>
            <input
              v-model="form.nome"
              class="sc-input"
              placeholder="Ex: Google Tag Manager, Facebook Pixel..."
              maxlength="100"
            />
          </div>

          <div class="sc-field">
            <label class="sc-label">
              Código do script <span class="sc-required">*</span>
              <span class="sc-label-hint">Cole o código completo incluindo a tag &lt;script&gt;</span>
            </label>
            <textarea
              v-model="form.script"
              class="sc-textarea"
              placeholder="&lt;script&gt;&#10;  // Seu código aqui&#10;&lt;/script&gt;"
              rows="12"
              spellcheck="false"
            ></textarea>
          </div>

          <div class="sc-field-row">
            <label class="sc-label">Status</label>
            <label class="sc-toggle sc-toggle--inline">
              <input type="checkbox" v-model="form.ativo" />
              <span class="sc-toggle-track">
                <span class="sc-toggle-thumb"></span>
              </span>
              <span class="sc-toggle-label">{{ form.ativo ? 'Ativo — será injetado no body' : 'Inativo — não será injetado' }}</span>
            </label>
          </div>
        </div>

        <div class="sc-modal-footer">
          <button class="sc-btn-cancel" @click="fecharModal">Cancelar</button>
          <button
            class="sc-btn-save"
            :disabled="salvando || !form.nome || !form.script"
            @click="salvar"
          >
            <span v-if="salvando" class="sc-mini-spinner"></span>
            <svg v-else width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ modal.editando ? 'Salvar alterações' : 'Criar script' }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ScriptConfig',
  data() {
    return {
      scripts: [],
      loading: true,
      erro: null,
      salvando: false,
      modal: { aberto: false, editando: false, id: null },
      form: { nome: '', script: '', ativo: true },
    }
  },
  mounted() {
    this.buscarScripts()
  },
  methods: {
    async buscarScripts() {
      try {
        this.loading = true
        this.erro = null
        const { data } = await this.$http.get('site-scripts')
        this.scripts = data
      } catch (e) {
        this.erro = 'Falha ao carregar scripts'
      } finally {
        this.loading = false
      }
    },

    abrirModal(script = null) {
      if (script) {
        this.modal = { aberto: true, editando: true, id: script.id }
        this.form = { nome: script.nome, script: script.script, ativo: !!script.ativo }
      } else {
        this.modal = { aberto: true, editando: false, id: null }
        this.form = { nome: '', script: '', ativo: true }
      }
    },

    fecharModal() {
      this.modal.aberto = false
    },

    async salvar() {
      if (!this.form.nome || !this.form.script) return
      this.salvando = true
      try {
        const payload = {
          nome: this.form.nome,
          script: this.form.script,
          ativo: this.form.ativo ? 1 : 0,
        }
        if (this.modal.editando) {
          await this.$http.put(`site-scripts/${this.modal.id}`, payload)
        } else {
          await this.$http.post('site-scripts', payload)
        }
        this.toast('Script salvo com sucesso!', 'CheckIcon', 'success')
        this.fecharModal()
        await this.buscarScripts()
      } catch (e) {
        const msg = e.response?.status === 401
          ? 'Sessão expirada. Faça login novamente.'
          : 'Falha ao salvar script'
        this.toast(msg, 'XIcon', 'danger')
      } finally {
        this.salvando = false
      }
    },

    async toggleAtivo(script) {
      try {
        await this.$http.put(`site-scripts/${script.id}`, {
          nome: script.nome,
          script: script.script,
          ativo: script.ativo ? 0 : 1,
        })
        await this.buscarScripts()
      } catch (e) {
        this.toast('Falha ao atualizar status', 'XIcon', 'danger')
      }
    },

    confirmarExclusao(script) {
      this.$bvModal.msgBoxConfirm(
        `Deseja excluir o script "${script.nome}"? Esta ação não pode ser desfeita.`,
        {
          title: 'Excluir script',
          okTitle: 'Excluir',
          okVariant: 'danger',
          cancelTitle: 'Cancelar',
          centered: true,
        }
      ).then(async (ok) => {
        if (!ok) return
        try {
          await this.$http.delete(`site-scripts/${script.id}`)
          this.toast('Script excluído!', 'CheckIcon', 'success')
          await this.buscarScripts()
        } catch (e) {
          this.toast('Falha ao excluir script', 'XIcon', 'danger')
        }
      })
    },

    previewScript(script) {
      const clean = script.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
      return clean.length > 80 ? clean.slice(0, 80) + '…' : clean || script.slice(0, 80) + '…'
    },

    formatDate(dt) {
      if (!dt) return ''
      return new Date(dt).toLocaleDateString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      })
    },

    toast(msg, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        props: { title: msg, icon, variant },
      })
    },
  },
}
</script>

<style scoped>
.sc-wrap {
  padding: 28px 32px;
  max-width: 900px;
  margin: 0 auto;
}

/* ── Header ── */
.sc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 16px;
  flex-wrap: wrap;
}
.sc-header-left { display: flex; align-items: center; gap: 12px; }
.sc-header-icon {
  width: 40px; height: 40px; border-radius: 10px;
  background: linear-gradient(135deg, rgba(232,106,16,0.15), rgba(245,185,53,0.15));
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.sc-header-title { font-size: 1rem; font-weight: 700; color: var(--dk-text-primary, #0D3349); }
.sc-header-sub { font-size: 0.8rem; color: var(--dk-text-muted, #8a94a6); margin-top: 2px; }

.sc-btn-new {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 9px 18px; border-radius: 10px; border: none;
  background: linear-gradient(135deg, #E86A10, #F5B935);
  color: #fff; font-size: 13px; font-weight: 600; cursor: pointer;
  box-shadow: 0 4px 14px rgba(232,106,16,0.28);
  transition: all 0.2s; white-space: nowrap;
}
.sc-btn-new:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(232,106,16,0.38); }
.sc-btn-new--sm { margin-top: 12px; }

/* ── Banner ── */
.sc-banner {
  display: flex; align-items: flex-start; gap: 10px;
  background: rgba(232,106,16,0.08); border: 1px solid rgba(232,106,16,0.2);
  border-radius: 10px; padding: 12px 16px;
  font-size: 0.82rem; color: var(--dk-text-secondary, #6b7a8d);
  line-height: 1.5; margin-bottom: 20px;
}
.sc-banner svg { flex-shrink: 0; margin-top: 1px; }
.sc-banner strong { color: var(--dk-text-primary, #0D3349); }
.sc-banner code {
  background: rgba(232,106,16,0.1); color: #E86A10;
  padding: 1px 5px; border-radius: 4px; font-family: monospace; font-size: 0.78rem;
}

/* ── Loading ── */
.sc-loading {
  display: flex; align-items: center; gap: 10px;
  color: var(--dk-text-muted, #8a94a6); font-size: 0.875rem;
  padding: 32px; justify-content: center;
}
.sc-spinner {
  width: 20px; height: 20px; border-radius: 50%;
  border: 2px solid rgba(232,106,16,0.2);
  border-top-color: #E86A10;
  animation: sc-spin 0.7s linear infinite;
}
@keyframes sc-spin { to { transform: rotate(360deg); } }

/* ── Error ── */
.sc-error {
  display: flex; align-items: center; gap: 8px;
  background: rgba(248,113,113,0.1); border: 1px solid rgba(248,113,113,0.25);
  border-radius: 10px; padding: 14px 16px;
  font-size: 0.875rem; color: #f87171;
}

/* ── Empty ── */
.sc-empty {
  text-align: center; padding: 56px 24px;
  color: var(--dk-text-muted, #8a94a6);
}
.sc-empty p { margin: 12px 0 0; font-weight: 600; font-size: 0.9rem; }

/* ── List ── */
.sc-list { display: flex; flex-direction: column; gap: 10px; }

.sc-card {
  display: flex; align-items: center; justify-content: space-between;
  background: var(--dk-card-bg, #1e2d3d); border: 1px solid var(--dk-border, rgba(255,255,255,0.06));
  border-radius: 12px; padding: 16px 18px; gap: 16px; flex-wrap: wrap;
  transition: border-color 0.2s;
}
.sc-card--active { border-color: rgba(232,106,16,0.3); }
.sc-card-left { display: flex; align-items: flex-start; gap: 12px; flex: 1; min-width: 0; }
.sc-card-icon {
  width: 34px; height: 34px; border-radius: 8px; flex-shrink: 0;
  background: rgba(232,106,16,0.12); color: #E86A10;
  display: flex; align-items: center; justify-content: center;
}
.sc-card-info { min-width: 0; }
.sc-card-nome { font-size: 0.9rem; font-weight: 700; color: var(--dk-text-primary, #e2e8f0); margin-bottom: 3px; }
.sc-card-preview {
  font-size: 0.75rem; color: var(--dk-text-muted, #8a94a6);
  font-family: 'Courier New', monospace;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 400px;
}
.sc-card-meta { font-size: 0.7rem; color: var(--dk-text-muted, #8a94a6); margin-top: 4px; }

.sc-card-right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }

/* ── Toggle ── */
.sc-toggle { display: inline-flex; align-items: center; gap: 8px; cursor: pointer; }
.sc-toggle input { display: none; }
.sc-toggle-track {
  width: 36px; height: 20px; border-radius: 10px;
  background: var(--dk-border, rgba(255,255,255,0.1));
  position: relative; transition: background 0.2s; flex-shrink: 0;
}
.sc-toggle input:checked + .sc-toggle-track { background: #E86A10; }
.sc-toggle-thumb {
  position: absolute; top: 2px; left: 2px;
  width: 16px; height: 16px; border-radius: 50%; background: #fff;
  transition: transform 0.2s; box-shadow: 0 1px 4px rgba(0,0,0,0.3);
}
.sc-toggle input:checked ~ .sc-toggle-track .sc-toggle-thumb,
.sc-toggle input:checked + .sc-toggle-track .sc-toggle-thumb { transform: translateX(16px); }

.sc-toggle--inline { flex-direction: row; }
.sc-toggle-label { font-size: 0.82rem; color: var(--dk-text-secondary, #6b7a8d); }

/* ── Badge ── */
.sc-badge {
  display: inline-flex; align-items: center;
  padding: 3px 9px; border-radius: 20px; font-size: 0.7rem; font-weight: 600;
}
.sc-badge--on { background: rgba(40,199,111,0.1); color: #28c76f; }
.sc-badge--off { background: rgba(168,170,174,0.08); color: #82868b; }

/* ── Action buttons ── */
.sc-btn-act {
  width: 30px; height: 30px; border-radius: 7px; border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center; transition: all 0.15s;
}
.sc-btn-edit {
  background: rgba(255,255,255,0.06); color: var(--dk-text-muted, #8a94a6);
}
.sc-btn-edit:hover { background: rgba(232,106,16,0.15); color: #E86A10; }
.sc-btn-delete {
  background: rgba(255,255,255,0.06); color: var(--dk-text-muted, #8a94a6);
}
.sc-btn-delete:hover { background: rgba(248,113,113,0.15); color: #f87171; }

/* ── Modal ── */
.sc-modal-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.65);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999; padding: 20px;
  backdrop-filter: blur(4px);
}
.sc-modal {
  background: var(--dk-card-bg, #1a2535);
  border: 1px solid var(--dk-border, rgba(255,255,255,0.08));
  border-radius: 16px; width: 100%; max-width: 640px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.5);
  display: flex; flex-direction: column; max-height: 90vh; overflow: hidden;
}
.sc-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 18px 22px; border-bottom: 1px solid var(--dk-border, rgba(255,255,255,0.08));
}
.sc-modal-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 0.95rem; font-weight: 700; color: var(--dk-text-primary, #e2e8f0);
}
.sc-modal-close {
  background: none; border: none; cursor: pointer;
  color: var(--dk-text-muted, #8a94a6); padding: 4px; border-radius: 6px;
  display: flex; align-items: center; transition: color 0.15s, background 0.15s;
}
.sc-modal-close:hover { color: var(--dk-text-primary, #e2e8f0); background: rgba(255,255,255,0.06); }

.sc-modal-body {
  padding: 20px 22px;
  overflow-y: auto;
  display: flex; flex-direction: column; gap: 16px;
  flex: 1;
}
.sc-modal-footer {
  padding: 14px 22px;
  border-top: 1px solid var(--dk-border, rgba(255,255,255,0.08));
  display: flex; justify-content: flex-end; gap: 10px;
}

/* ── Form fields ── */
.sc-field { display: flex; flex-direction: column; gap: 7px; }
.sc-field-row { display: flex; flex-direction: column; gap: 8px; }
.sc-label {
  font-size: 12.5px; font-weight: 600;
  color: var(--dk-text-primary, #e2e8f0);
  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
}
.sc-label-hint { font-size: 11px; font-weight: 400; color: var(--dk-text-muted, #8a94a6); }
.sc-required { color: #E86A10; }

.sc-input, .sc-textarea {
  width: 100%;
  background: rgba(255,255,255,0.04);
  border: 1.5px solid var(--dk-border, rgba(255,255,255,0.1));
  border-radius: 10px;
  color: var(--dk-text-primary, #e2e8f0);
  font-size: 13px; font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}
.sc-input { padding: 11px 14px; }
.sc-textarea {
  padding: 12px 14px;
  font-family: 'Courier New', Consolas, monospace;
  font-size: 12px; line-height: 1.6;
  resize: vertical; min-height: 220px;
}
.sc-input::placeholder, .sc-textarea::placeholder { color: rgba(138,148,166,0.5); }
.sc-input:focus, .sc-textarea:focus {
  border-color: #E86A10;
  box-shadow: 0 0 0 3px rgba(232,106,16,0.12);
}

/* ── Modal buttons ── */
.sc-btn-cancel {
  padding: 9px 18px; border-radius: 9px;
  background: rgba(255,255,255,0.06);
  border: 1px solid var(--dk-border, rgba(255,255,255,0.1));
  color: var(--dk-text-secondary, #6b7a8d);
  font-size: 13px; font-weight: 600; cursor: pointer;
  transition: all 0.15s;
}
.sc-btn-cancel:hover { background: rgba(255,255,255,0.1); }
.sc-btn-save {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 9px 20px; border-radius: 9px; border: none;
  background: linear-gradient(135deg, #E86A10, #F5B935);
  color: #fff; font-size: 13px; font-weight: 700; cursor: pointer;
  transition: all 0.2s; box-shadow: 0 4px 14px rgba(232,106,16,0.28);
}
.sc-btn-save:hover:not(:disabled) { transform: translateY(-1px); }
.sc-btn-save:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }

.sc-mini-spinner {
  width: 14px; height: 14px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  animation: sc-spin 0.6s linear infinite;
  display: block;
}

@media (max-width: 600px) {
  .sc-wrap { padding: 16px; }
  .sc-card { flex-direction: column; align-items: flex-start; }
  .sc-card-right { width: 100%; justify-content: flex-end; }
  .sc-card-preview { max-width: 100%; }
}
</style>

<style>
/* Unscoped overrides for Vuexy theme conflicts */
.sc-wrap .sc-input,
.sc-wrap .sc-textarea {
  width: 100% !important;
  background: rgba(255,255,255,0.05) !important;
  border: 1.5px solid rgba(255,255,255,0.12) !important;
  border-radius: 10px !important;
  color: #e2e8f0 !important;
  font-size: 13px !important;
  outline: none !important;
  box-shadow: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
}
.sc-wrap .sc-input { padding: 11px 14px !important; font-family: inherit !important; }
.sc-wrap .sc-textarea {
  padding: 14px 16px !important;
  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace !important;
  font-size: 12.5px !important; line-height: 1.6 !important;
  resize: vertical !important; min-height: 240px !important;
}
.sc-wrap .sc-input::placeholder,
.sc-wrap .sc-textarea::placeholder { color: rgba(138,148,166,0.45) !important; }
.sc-wrap .sc-input:focus,
.sc-wrap .sc-textarea:focus {
  border-color: #E86A10 !important;
  box-shadow: 0 0 0 3px rgba(232,106,16,0.15) !important;
  background: rgba(255,255,255,0.07) !important;
}

.sc-wrap .sc-modal-overlay {
  position: fixed !important; inset: 0 !important;
  background: rgba(0,0,0,0.7) !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  z-index: 9999 !important; padding: 20px !important;
  backdrop-filter: blur(6px) !important;
}
.sc-wrap .sc-modal {
  background: #152233 !important;
  border: 1px solid rgba(255,255,255,0.08) !important;
  border-radius: 16px !important; width: 100% !important; max-width: 640px !important;
  box-shadow: 0 32px 80px rgba(0,0,0,0.5) !important;
  display: flex !important; flex-direction: column !important; max-height: 90vh !important; overflow: hidden !important;
}
.sc-wrap .sc-modal-header {
  display: flex !important; align-items: center !important; justify-content: space-between !important;
  padding: 20px 24px !important; border-bottom: 1px solid rgba(255,255,255,0.08) !important;
  background: rgba(255,255,255,0.02) !important;
}
.sc-wrap .sc-modal-title {
  display: flex !important; align-items: center !important; gap: 8px !important;
  font-size: 0.95rem !important; font-weight: 700 !important; color: #fff !important;
}
.sc-wrap .sc-modal-body {
  padding: 24px !important; overflow-y: auto !important;
  display: flex !important; flex-direction: column !important; gap: 20px !important; flex: 1 !important;
}
.sc-wrap .sc-modal-footer {
  padding: 16px 24px !important; border-top: 1px solid rgba(255,255,255,0.08) !important;
  display: flex !important; justify-content: flex-end !important; gap: 10px !important;
  background: rgba(255,255,255,0.02) !important;
}
.sc-wrap .sc-label {
  font-size: 12px !important; font-weight: 700 !important; color: #94a3b8 !important;
  text-transform: uppercase !important; letter-spacing: 0.5px !important;
  display: flex !important; align-items: center !important; gap: 6px !important; flex-wrap: wrap !important;
}
.sc-wrap .sc-label-hint { font-size: 11px !important; font-weight: 400 !important; color: #64748b !important; text-transform: none !important; letter-spacing: 0 !important; }
.sc-wrap .sc-btn-cancel {
  padding: 10px 20px !important; border-radius: 10px !important;
  background: rgba(255,255,255,0.06) !important; border: 1px solid rgba(255,255,255,0.12) !important;
  color: #94a3b8 !important; font-size: 13px !important; font-weight: 600 !important; cursor: pointer !important;
}
.sc-wrap .sc-btn-cancel:hover { background: rgba(255,255,255,0.1) !important; color: #e2e8f0 !important; }
.sc-wrap .sc-btn-save {
  display: inline-flex !important; align-items: center !important; gap: 6px !important;
  padding: 10px 22px !important; border-radius: 10px !important; border: none !important;
  background: linear-gradient(135deg, #E86A10, #d45e0c) !important;
  color: #fff !important; font-size: 13px !important; font-weight: 700 !important; cursor: pointer !important;
  box-shadow: 0 4px 14px rgba(232,106,16,0.3) !important;
}
.sc-wrap .sc-btn-save:hover:not(:disabled) { transform: translateY(-1px) !important; box-shadow: 0 6px 20px rgba(232,106,16,0.4) !important; }
.sc-wrap .sc-btn-save:disabled { opacity: 0.5 !important; cursor: not-allowed !important; transform: none !important; }
.sc-wrap .sc-toggle-label { font-size: 0.82rem !important; color: #94a3b8 !important; }